/*
 * @Author: your name
 * @Date: 2022-03-02 09:37:31
 * @LastEditTime: 2024-08-23 17:21:16
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsySLoading\index.jsx
 */
import React, { Component } from "react";
import "./index.css";

class BsySLoading extends Component {
  static defaultProps = {
    mode: "circling", //circling 转圈圈 skeletonspin 条状
    text: "",
    hasTitle: !1,
    rowNum: -1,
    customCls: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      mode: props.mode,
      text: props.text,
      height: props.height,
      width: props.width,
      hasTitle: props.hasTitle,
      rowNum: props.rowNum,
      customCls: props.customCls,
    };
    this.element = React.createRef();
  }

  componentDidMount() {
    this.setState({});
  }

  renderSkeletonspinRow = () => {
    const { rowNum, hasTitle } = this.state;
    if (!this.element.current) {
      return <></>;
    }
    let s = rowNum;
    if (rowNum === -1) {
      let o = this.element.current.offsetHeight - 15;
      hasTitle && (o -= 30);
      s = parseInt(o / 40);
    }
    let arrs = new Array(s);
    arrs.fill(1);
    return (
      <>
        {arrs.map((row, index) => {
          return <div key={"load" + index + ""} className="skeleton-line" />;
        })}
      </>
    );
  };

  renderAnimation = () => {
    const { width, height, mode, hasTitle, text } = this.state;
    switch (mode) {
      case "skeletonspin": {
        return (
          <div
            className="x-skeleton-spin"
            style={{ width: width, height: height }}
          >
            {hasTitle && <div className="skeleton-line title" />}
            {this.renderSkeletonspinRow()}
          </div>
        );
      }
      // case "circling": {
      //     return <div className="isLoading" style={{ width: width, height: height }} />
      // }
      case "dotLoading": {
        return (
          <div className="bsy-dot-loading-box">
            <div className="dot1"></div>
            <div className="dot2"></div>
            <div className="dot3"></div>
          </div>
        );
      }
      default: {
        return (
          <>
            <div
              className="isLoading"
              style={{ width: width, height: height }}
            />{" "}
            {text && <span className="title">{text}</span>}
          </>
        );
      }
    }
  };

  render() {
    return (
      <div
        className={"BsySLoading " + this.state.customCls}
        style={{ zIndex: window.FX.STATIC.zIndex++, ...this.props.style }}
        ref={this.element}
      >
        {this.renderAnimation()}
      </div>
    );
  }
}

export default BsySLoading;
